module.exports = __webpack_public_path__ + "img/tu_schedule_dayoff_active.8d33657a.svg";